import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { Map, fromJS } from "immutable";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { QUOTE_TYPE } from "MODULES/OutgoingQuotes/constants";
import {
  CONDITION,
  TAG_DATE,
  SUGGESTED_RETAIL,
  TAGGED_BY,
  LEAD_TIME,
  TAGGED_BY_ID,
  FAA,
  EASA,
  CAAC,
  OTHER_TAG_TYPE,
  TCCA,
  UK_CAA,
  PART_ID
} from "MODULES/inventories/constants";
import { DOM, PART } from "MODULES/parts/constants";
import { BUYER_ID, USER } from "MODULES/users/constants";
import { COMPANY } from "MODULES/PurchaseOrders/constants";
import {
  CITY,
  COUNTRY,
  COST,
  QUANTITY,
  ID,
  STATE,
  SUBTOTAL,
  SETTINGS,
  BUYER_CREDIT_PCT,
  LINE_ITEMS
} from "APP_ROOT/constants";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { isEmpty } from "lodash";
import { defaultStoreLocation } from "APP_ROOT/hooks/useCurrentUser";
import Form from "./Form";
import { convertQuoteToPurchaseOrder, getCompany } from "../../actions";
import {
  STANDARD,
  AS_IS,
  INCIDENT_RELATED,
  EXCHANGE_ONLY,
  PURCHASE_STATUS
} from "../../constants";
import pojo from "../../../../lib/pojos";

const convertibleQuoteTypes = [
  STANDARD,
  AS_IS,
  INCIDENT_RELATED,
  EXCHANGE_ONLY
];

class ConvertToPurchaseOrder extends Component {
  static propTypes = {
    buyerCreditPct: PropTypes.string,
    currentUser: PropTypes.instanceOf(Map),
    subtotal: PropTypes.number.isRequired,
    incomingQuote: PropTypes.instanceOf(Map),
    convertToPurchaseOrder: PropTypes.func.isRequired
  };

  state = {
    company: null
  };

  componentDidMount() {
    const companyId = this.props.incomingQuote.getIn([COMPANY, ID]);
    getCompany(companyId).then(company => this.setState({ company }));
  }

  handleSubmit = values => {
    const includedLineItems = values.line_items.filter(i => i.included);
    const filteredValues = fromJS(values)
      .merge({ line_items: includedLineItems })
      .toJS();

    return this.props.convertToPurchaseOrder(filteredValues);
  };

  convertibleLineItems = () =>
    this.props.incomingQuote
      .get("incoming_quote_line_items")
      .filter(
        item => convertibleQuoteTypes.indexOf(item.get(QUOTE_TYPE)) !== -1
      )
      .toJS();

  render() {
    const { buyerCreditPct, currentUser, incomingQuote, subtotal } = this.props;
    const { company } = this.state;
    const lineItems = this.convertibleLineItems();
    const address = incomingQuote.getIn(
      [COMPANY, "primary_physical_address"],
      Map()
    );

    const initialValues = {
      buyer_id: incomingQuote.get(BUYER_ID),
      buyer_credit_pct: buyerCreditPct,
      buying_store_id: defaultStoreLocation(currentUser),
      fob:
        address.size > 0
          ? [address.get(CITY), address.get(STATE), address.get(COUNTRY)].join(
              "-"
            )
          : null,
      payment_terms: incomingQuote.getIn([COMPANY, "vendor_credit_terms"]),
      line_items: lineItems.map(item => ({
        evaluation_period: 30,
        expected_serial_number:
          Number(item.quantity) === 1 ? item.expected_serial_number : null,
        included: true,
        incoming_quote_line_item_id: item.id,
        other: !isEmpty(item.other_tag_type),
        reserve_for_seller_id: currentUser.id,
        hazmat: item.part.hazmat,
        srp_condition: item.condition,
        ...pojo(item).pick(
          CAAC,
          CONDITION,
          COST,
          DOM,
          EASA,
          FAA,
          LEAD_TIME,
          OTHER_TAG_TYPE,
          PART,
          PART_ID,
          PURCHASE_STATUS,
          QUANTITY,
          SUBTOTAL,
          SUGGESTED_RETAIL,
          TAGGED_BY_ID,
          TAG_DATE,
          TAGGED_BY,
          TCCA,
          UK_CAA
        )
      }))
    };

    if (lineItems.length === 0) return null;

    return (
      <ToggleSwitch>
        {(visible, open, close) => (
          <DropDownItem onClick={open}>
            <Icon name="shopping-cart" fixed />
            &nbsp;Convert to PO
            <Modal open={visible} close={close} dialogClass="modal-lg">
              <Header>
                <Close close={close} />
                <h4 className="modal-title">Convert Quote to Purchase Order</h4>
              </Header>
              <Form
                onSubmit={this.handleSubmit}
                initialValues={initialValues}
                close={close}
                lineItems={lineItems}
                subtotal={subtotal}
                company={company}
                incomingQuote={incomingQuote}
                enableReinitialize
              />
            </Modal>
          </DropDownItem>
        )}
      </ToggleSwitch>
    );
  }
}

const selector = formValueSelector("incomingQuoteConvertToPurchaseOrders");

export default connect(
  state => ({
    buyerCreditPct: state.session.getIn([SETTINGS, BUYER_CREDIT_PCT]),
    currentUser: state.session.get(USER).toJS(),
    subtotal: (selector(state, LINE_ITEMS) || [])
      .filter(item => item.included)
      .reduce(
        (total, item) =>
          total + parseFloat(item.cost) * parseFloat(item.quantity),
        0
      )
  }),
  dispatch => ({
    convertToPurchaseOrder: ids => dispatch(convertQuoteToPurchaseOrder(ids))
  })
)(ConvertToPurchaseOrder);



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/ConvertToPurchaseOrder/ConvertToPurchaseOrder.jsx